/**
 * 키보드 이벤트의 타깃이 사용자가 글자를 입력 중인 곳인지 판정한다.
 * 지도 도구의 Esc 취소 배선(2D `useDrawingCancelKey`, 3D `useToolCancelKey`)이 이 판정 하나를 읽어,
 * 입력 중의 Esc(조합 취소·값 되돌리기)를 도구가 가로채지 않게 한다.
 *
 * 타깃 자신뿐 아니라 조상까지 본다 — contenteditable 편집기 안의 자식 노드가 타깃이 되는 경우가 있다.
 *
 * Esc 취소 두 훅만 여기를 읽는다 — 다른 키 배선(`useClipUndoKey`·`use3DFlightControls`)은
 * 아직 각자의 사설 판정을 갖고 있다.
 */
const TEXT_ENTRY_SELECTOR =
  'input, textarea, select, [contenteditable]:not([contenteditable="false"])';

export function isTextEntryTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(TEXT_ENTRY_SELECTOR) !== null;
}
